/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ItineratorError, ItineratorFormEntry, ItineratorFormEntryForm } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FormEntries<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags FormEntry
   * @name PostFormEntries
   * @summary Create a form entries
   * @request POST:/form_entries
   * @secure
   */
  postFormEntries = (data: ItineratorFormEntryForm, params: RequestParams = {}) =>
    this.request<ItineratorFormEntry, ItineratorError>({
      path: `/form_entries`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
